/**
 * Service to fetch teacher connection information for parents
 */
import { supabase } from './supabase';
import { getApiUrl } from './apiConfig';

export const fetchTeacherConnection = async (studentName) => {
  try {
    // Get JWT token for authentication
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError || !session?.access_token) {
      console.error('No valid session found:', sessionError);
      return null;
    }
    
    // For other students, try to fetch from backend
    const response = await fetch(getApiUrl(`student-details?student_name=${studentName}`), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const studentData = await response.json();
    
    // Return teacher name directly from student profile if available
    if (studentData.teacher) {
      return {
        FullName: studentData.teacher,
        Subject: 'General' // You can update this to fetch the actual subject from teacher profile if needed
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error fetching teacher connection:', error);
    return null;
  }
};
